module.exports = __webpack_public_path__ + "img/ao.ab8cc21b.svg";